<script>
import {
  layoutMethods,
  erpUsersMethods,
  erpUsersComputed,
  erpUserRolesMethods,
  erpUserRolesComputed
} from "@/state/helpers";
import Swal from "sweetalert2";
import { getModuleAccess } from '@/router/helper.js'

/**
 * User list component
 */
export default {
  page: {
    title: "Users",
  },
  data() {
    return {
      title: "Users",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "u.name",
      sortDesc: false,
      fields: [
        {
          key: "action",
          sortable: false,
        },
        {
          key: "name",
          sortable: true,
        },
        {
          key: "position",
          sortable: true,
        },
        {
          key: "role",
          sortable: false,
        },
        {
          key: "department",
          sortable: true,
        },
        {
          key: "line_manager_email",
          label: "Line Manager",
          sortable: true,
        },
        // {
        //   key: "activity",
        //   sortable: false,
        // },
      ],
      contact: {
        name: "",
        designation: "",
        email: "",
        file: "",
      },
      searchValue: {
        search: null,
        searchField: null,
        role:null,
        department:null,
      },
      form: {
        searchUser: null,
      },
      searchListUser: [
        { text: "All", value: null },
        { text: "Name", value: "u.name" },
        { text: "Email", value: "u.email" },
        { text: "Position", value: "u.position" },
        { text: "Department", value: "u.department" },
        { text: "Line Manager", value: "u.line_manager_email" },
      ],
      roleOptions: [
        { text: "All", value: null },
        { text: "Unassigned", value: 0 }
      ],
      departmentOptions: [
        { text: "All", value: null }
      ],
      refreshPage: false,
      userProfileImg: "@/assets/images/users/avatar-1.jpg",
      moduleAccess: {
          create: false,
          read: false,
          update: false,
          delete: false
      }
    };
  },
  computed: {
    ...erpUsersComputed,
    ...erpUserRolesComputed,
  },
  mounted: async function () {
    // Set the initial number of items
    this.changeTitle({ title: "Users" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Users", to: { name: "Users" } },
      ],
    });

    this.getUsers();
    this.getRoles();
    this.getDepartments();
    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'User Management', 'Users')
      .then((access) => this.moduleAccess = access);
  },
  methods: {
    ...layoutMethods,
    ...erpUsersMethods,
    ...erpUserRolesMethods,
    checkAll() {
      const checkAll = document.getElementById("checkAll");
      if (checkAll) {
        checkAll.onclick = function () {
          const checkboxes = document.querySelectorAll(
            '.table-check input[type="checkbox"]'
          );
          for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = this.checked;
          }
        };
      }
    },
    getUsers: async function () {
      await this.getErpUsersList({
        body: {
          page: this.refreshPage ? 1 : this.currentPage,
          rows: this.refreshPage ? 10 : this.perPage,
          search_field: this.refreshPage ? "" : this.searchValue.searchField,
          search: this.refreshPage ? "" : this.searchValue.search,
          sort: this.refreshPage ? "id" : this.sortBy,
          sortDesc: this.refreshPage ? false : this.sortDesc,
          role: this.searchValue.role,
          department: this.searchValue.department,
          email: "jero.balucas@peddlr.ph",
        },
      });

      this.searchValue.search = this.refreshPage ? null : this.searchValue.search;
      this.searchValue.searchField = this.refreshPage ? null : this.searchValue.searchField;
      this.refreshPage = false;
      // console.log("erpUsersList: ", this.erpUsersList);
    },
    manageUser(item) {
      this.$router.push({ path: `user/${item.id}` });
    },
    tableSorting(action) {
      console.log(action);
      switch (action.sortBy) {
        case "name":
          this.sortBy = "u.name";
          break;
        case "position":
          this.sortBy = "u.position";
          break;
        case "department":
          this.sortBy = "u.department";
          break;
        case "line_manager":
          this.sortBy = "u.line_manager_email";
          break;
      }
      this.sortDesc = action.sortDesc;
      this.getUsers();
    },
    setPhoto(photo) {
      return photo != "" || photo != null ? `data:image/jpeg;base64,${photo}` : this.userProfileImg;
    },
    getRoles: async function () {
      var self= this;
      await this.getAllRoles();
      this.rolesList.map(function (role) {
        self.roleOptions.push({
          text: role.name,
          value: role.id,
        });
      });
    },
    async getDepartments(){
      await this.actionERPUsers({
          action: "get-all-department",
          body: {}
      })
      .then((res) => {
        if(res.message.length > 0){
          for(let r of res.message){
            this.departmentOptions.push(r);
          }
        }
        // console.log(res);
      }).catch((e)=>{
        console.log("error while getting list",e);
      });
    },
    deleteErpUser(user){
      try {
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to delete ${user.name}`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
              this.confirmDeleteUser(user);
            }else{
                return;
            }
        })
      } catch (error) {
        console.log("user >> ",JSON.stringify(user));
        console.log("ERR >> ",error);
      }
    },
    async confirmDeleteUser(user){
      await this.actionERPUsers({
          action: "delete-erp-user",
          body: {
            "user_id":user.id
          }
      })
      .then((res) => {
        // console.log(res);
        if(res.status == "ok"){
          Swal.fire(
            "Success",
            `${user.name} is deleted successfully.`,
            "success"
          );
          // this.refreshPage = true;
          this.getUsers();
        }else{
          Swal.fire(
            "Oops",
            res.message,
            "warning"
          );
        }
      }).catch((e)=>{
        console.log("error while deleting user:",e);
        Swal.fire(
          "Oops",
          e,
          "warning"
        );
      });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{ erpUsersTotalRows }} Record(s)</span>
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6 col-sm-6">
                  <div class="d-flex justify-content-lg-end mb-lg-3">
                      <a class="btn btn-secondary" @click="getUsers()"
                          ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                          ></feather
                          >&nbsp;&nbsp; Refresh</a
                      >
                  </div>
              </div>
              <!--end of header buttons-->

              <!-- Search and button -->
              <div class="row mt-3 mb-2 px-3">
                <div class="w-auto mb-2">
                  <div class="d-flex mt-3 mb-3">
                    <div class="me-3">
                      <form class="d-flex" @submit.prevent="getUsers()">
                        <b-form-group id="input-group-3" label-for="input-3">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" 
                          v-model="searchValue.searchField" :options="searchListUser"></b-form-select>
                        </b-form-group>
                        <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                          <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                          <b-form-input id="input-keyword" v-model="searchValue.search" class="rounded-0" style="width: auto"></b-form-input>
                        </b-form-group>
                      </form>
                    </div><!--search box-->

                    <div class="me-3 ta-right">
                      <b-form-group label-for="transaction-status" description="Filter by Role">
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:120px"
                          id="transaction-status"
                          v-model="searchValue.role"
                          :options="roleOptions"
                        ></b-form-select>
                      </b-form-group>
                    </div><!--filter by role-->

                    <div class="me-3 ta-right">
                      <b-form-group label-for="transaction-status" description="Filter by Department">
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:120px"
                          id="transaction-status"
                          v-model="searchValue.department"
                          :options="departmentOptions"
                        ></b-form-select>
                      </b-form-group>
                    </div><!--filter by dept-->
                    <div class="me-3">
                        <b-button variant="primary" type="button" @click="getUsers()" class="px-2 me-2">
                          <i class='bx bx-search bx-fw'></i>
                          Search
                        </b-button>
                    </div>
                  </div><!--end of filter div-->
                </div>
                <div class="col-md-5" v-if="false">
                  <form class="d-flex" @submit.prevent="getUsers()">
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width: 160px"
                        id="input-3" v-model="searchValue.searchField" :options="searchListUser"></b-form-select>
                    </b-form-group>

                    <b-input-group>
                      <b-form-input v-model="searchValue.search" class="rounded-0"></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary" class="rounded-0 rounded-end px-2" type="submit">
                          <i class="bx bx-search bx-fw"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </form>
                </div>

                <div class="col-md-7 mt-2 mt-lg-0" v-if="false">
                  <div class="d-flex justify-content-lg-end">
                    <div class="d-flex flex-wrap align-items-start justify-content-md-end mt-2 mt-md-0 gap-2 mb-3">
                      <a class="btn btn-secondary" @click="refreshPage = true; getUsers();">
                        <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table :items="erpUsersList" :fields="fields" responsive="sm" :current-page="currentPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @sort-changed="tableSorting" class="table-check">
                  <template #cell(action)="data">
                    <b-button variant="danger" class="p-1" @click="deleteErpUser(data.item)" v-if="moduleAccess.delete"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                    <b-button variant="danger" class="p-1" v-if="!moduleAccess.delete" disabled><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                  </template>
                  <template #cell(name)="data">
                    <div class="d-flex">
                      <img :src="setPhoto(data.item.photo)" alt="" class="avatar rounded-circle me-2" @error="
                        (e) =>
                          (e.target.src = require('@/assets/images/user_icon.png'))
                      " />
                      <div class="ms-1">
                        <b-link class="fw-medium" @click="manageUser(data.item)">{{ data.item.name }}
                        </b-link>
                        <!-- <p class="text-body fw-medium m-0">{{ data.item.name }}</p> -->
                        <p class="text-body fw-small small m-0">
                          {{ data.item.email }}
                        </p>
                      </div>
                      <!-- <router-link
                        to="/pages/profile"
                        class="text-body fw-medium"
                        >{{ data.item.name }}
                      </router-link> -->
                    </div>
                  </template>

                  <template #cell(position)="data">
                    <div style="width: 150px; white-space: normal">
                      <p class="text-body fw-small small m-0">
                        {{ data.item.position }}
                      </p>
                    </div>
                  </template>

                  <template #cell(role)="data">
                    <!-- <div class="badge badge-soft-secondary" v-if="data.item.role != null">
                      {{ data.item.role_name }}
                    </div> -->
                    <p class="text-body fw-small small m-0">
                      {{ data.item.roleName }}
                    </p>
                  </template>

                  <template #cell(department)="data">
                    <p class="text-body fw-small small m-0">
                      {{ data.item.department }}
                    </p>
                  </template>

                  <template #cell(line_manager_email)="data">
                    <p class="text-body fw-small small m-0">
                      {{ data.item.line_manager_email }}
                    </p>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="erpUsersTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="erpUsersTotalRows != 0 && erpUsersTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <!-- pagination -->
                      <b-pagination class="pagination-rounded" v-model="currentPage" :total-rows="erpUsersTotalRows"
                        :per-page="perPage" @input="getUsers()"></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
